import { Button, Helper, Input } from '@smartgift/frontend-toolkit';
import debounce from 'lodash/debounce';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';

import * as S from './style';

const { MenuList } = components;

function CustomMenuList({ selectProps, ...props }) {
  const { t } = useTranslation();
  const [minPriceRef, setMinPriceRef] = useState();
  const [menuListRef, setMenuListRef] = useState();

  const {
    isMulti,
    menuIsOpen,
    value,
    appliable,
    minPrice,
    maxPrice,
    onMinPriceChange,
    onMaxPriceChange
  } = selectProps;

  const onBlur = e => {
    const { inputValue: prevInputValue } = selectProps;

    if (menuListRef && menuListRef.contains(document.activeElement)) {
      return;
    }

    if (selectProps.onBlur) {
      selectProps.onBlur(e);
    }

    selectProps.onInputChange('', { action: 'input-blur', prevInputValue });
    selectProps.onMenuClose();
  };

  useEffect(() => {
    minPriceRef?.focus();
  }, [menuIsOpen, minPriceRef]);

  const [error, setError] = useState('');

  useEffect(() => {
    if (maxPrice && minPrice && Number(maxPrice) < Number(minPrice)) {
      setError('Max price should be greater than min price');
    } else {
      setError('');
    }
  }, [maxPrice, minPrice]);

  return (
    <S.MenuListWrapper>
      <MenuList {...props} innerRef={setMenuListRef} selectProps={selectProps}>
        <S.PriceInputContainer>
          <Input
            size="sm"
            ref={setMinPriceRef}
            value={minPrice?.toString()}
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            onChange={e => {
              e.stopPropagation();
              e.preventDefault();
              onMinPriceChange(e);
            }}
            onKeyDown={e => {
              e.stopPropagation();
            }}
            onMouseDown={e => {
              e.stopPropagation();
            }}
            autocomplete="off"
            placeholder={t('minPrice')}
            type="number"
            onBlur={e => {
              debounce(onBlur, 100)(e);
            }}
          />
          <Input
            size="sm"
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            value={maxPrice?.toString()}
            onChange={e => {
              e.stopPropagation();
              e.preventDefault();
              onMaxPriceChange(e);
            }}
            onKeyDown={e => {
              e.stopPropagation();
            }}
            onMouseDown={e => {
              e.stopPropagation();
            }}
            autocomplete="off"
            type="number"
            placeholder={t('maxPrice')}
            onBlur={e => {
              debounce(onBlur, 100)(e);
            }}
          />
        </S.PriceInputContainer>
        <Helper error={error} text={error} />
        {props.children}
      </MenuList>
      {(isMulti || appliable) && (
        <S.ActionButtons>
          <Button
            variant="text"
            size="sm"
            onClick={() => {
              selectProps.onCancel();
              selectProps.onMenuClose();
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            disabled={(!value && !minPrice && !maxPrice) || !!error}
            onClick={() => {
              selectProps.onApply();
              selectProps.onMenuClose();
            }}
            size="sm"
          >
            {t('apply')}
          </Button>
        </S.ActionButtons>
      )}
    </S.MenuListWrapper>
  );
}

export { CustomMenuList };
